import { render, staticRenderFns } from "./purchaseList.vue?vue&type=template&id=4645b6f0&"
import script from "./purchaseList.vue?vue&type=script&lang=js&"
export * from "./purchaseList.vue?vue&type=script&lang=js&"
import style0 from "./purchaseList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports